import { render, staticRenderFns } from "./MkLink.vue?vue&type=template&id=58bd9ced&scoped=true"
import script from "./MkLink.vue?vue&type=script&lang=js"
export * from "./MkLink.vue?vue&type=script&lang=js"
import style0 from "./MkLink.vue?vue&type=style&index=0&id=58bd9ced&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bd9ced",
  null
  
)

export default component.exports